<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-12 text-center">
                    <template v-for="(tab, index) in tabs">
                        <button :key="index" class="button m-3" :class="show == tab.tab ? 'site-content' : 'altcolor-content'" @click="show = tab.tab">{{ tab.nombre }}</button>
                    </template>
                </div>
            </div>
            <div class="row">
                <transition name="fade" mode="out-in">
                    <template v-for="(tab, index) in tabs">
                        <div class="col-12" :key="index" v-if="show == tab.tab">
                            <slot :name="setTabName(tab.tab)"></slot>
                        </div>
                    </template>  
                </transition>              
            </div>            
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            tabs: Array,
            initialTab: String
        },
        data() {
            return {
                show: this.initialTab
            }
        },
        methods: {
            setTabName(name) {
                return `${name}`;
            }            
        }
    }
</script>
